'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const tslib = require('tslib');
const utils = require('../utils.js');
const index = require('../numbers/index.js');
const utils$1 = require('./utils.js');

var clampRgbUnit = utils.clamp(0, 255);
var rgbUnit = tslib.__assign(tslib.__assign({}, index.number), {
  transform: function (v) {
    return Math.round(clampRgbUnit(v));
  }
});
var rgba = {
  test: utils$1.isColorString('rgb', 'red'),
  parse: utils$1.splitColor('red', 'green', 'blue'),
  transform: function (_a) {
    var red = _a.red,
      green = _a.green,
      blue = _a.blue,
      _b = _a.alpha,
      alpha$1 = _b === void 0 ? 1 : _b;
    return 'rgba(' + rgbUnit.transform(red) + ', ' + rgbUnit.transform(green) + ', ' + rgbUnit.transform(blue) + ', ' + utils.sanitize(index.alpha.transform(alpha$1)) + ')';
  }
};

exports.rgbUnit = rgbUnit;
exports.rgba = rgba;
